import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,
  regions: [
    {
      id: "hero",
      x: 0.035,
      y: 0.12,
      width: 0.62,
      height: 0.78,
    },
    {
      id: "detail_a",
      x: 0.69,
      y: 0.2,
      width: 0.27,
      height: 0.22,
    },
    {
      id: "detail_b",
      x: 0.69,
      y: 0.45,
      width: 0.27,
      height: 0.22,
    },
    {
      id: "detail_c",
      x: 0.69,
      y: 0.7,
      width: 0.27,
      height: 0.2,
    },
  ],
  textFields: [
    {
      id: "marca",
      x: 0.035,
      y: 0.03,
      width: 0.35,
      height: 0.055,
      fontSize: 56,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "#151515",
    },
  ],
};

const frameSx = {
  border: "1px solid #d8d8d8",
  borderRadius: "8px",
  background:
    "linear-gradient(135deg, rgba(250,250,250,1) 0%, rgba(236,236,236,1) 100%)",
  overflow: "hidden",
};

function PlantillaPremiumEditorial({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#f8f8f8",
        border: "1px solid #d0d0d0",
        borderRadius: "10px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "3.5%",
          top: "3%",
          width: "35%",
          height: "5.5%",
          bgcolor: "#151515",
          color: "#fff",
          px: 1.2,
          display: "flex",
          alignItems: "center",
          borderRadius: "4px",
        }}
      >
        <Typography sx={{ fontSize: ".28rem", fontWeight: 700, letterSpacing: 0.2 }}>
          {marca}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: "3.5%",
          top: "12%",
          width: "62%",
          height: "78%",
          ...frameSx,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            border: "1px dashed #a9a9a9",
            borderRadius: "8px",
          }}
        />
      </Box>

      {[
        { top: "20%", height: "22%" },
        { top: "45%", height: "22%" },
        { top: "70%", height: "20%" },
      ].map((slot, idx) => (
        <Box
          key={idx}
          sx={{
            position: "absolute",
            left: "69%",
            top: slot.top,
            width: "27%",
            height: slot.height,
            ...frameSx,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              border: "1px dashed #a9a9a9",
              borderRadius: "8px",
            }}
          />
        </Box>
      ))}

      <Box
        sx={{
          position: "absolute",
          right: "4%",
          top: "12%",
          width: "27%",
          height: "4%",
          borderBottom: "1px solid #b7b7b7",
          opacity: 0.7,
        }}
      />
    </Box>
  );
}

export default PlantillaPremiumEditorial;
